import { BILLING_CYCLE } from '@/common/constants';
import { capitalizeFirstLetter } from '@/common/utils';
import { translation } from '@/plugins/i18n';

export const CycleSort = {
  [BILLING_CYCLE.MONTHLY]: 4,
  [BILLING_CYCLE.ANNUAL]: 3,
  [BILLING_CYCLE.ONE_MONTH]: 2,
  [BILLING_CYCLE.ONE_TIME]: 1,
};

export const getBillingCycletranslationByKey = (cycle) => {
  return {
    [BILLING_CYCLE.MONTHLY]: `${translation('billing.billing_cycle.monthly')} ${translation('billing.billing_cycle.subscription')}`,
    [BILLING_CYCLE.ANNUAL]: `${capitalizeFirstLetter(translation('billing.billing_cycle.annual'))} ${translation('billing.billing_cycle.subscription')}`,
    [BILLING_CYCLE.ONE_MONTH]: `${translation('billing.billing_cycle.one_month_new')}`,
    [BILLING_CYCLE.ONE_TIME]: `${translation('billing.billing_cycle.one_time')}`,
    [BILLING_CYCLE.TWO_YEARS]: `${translation('billing.billing_cycle.two_years')}`,
    [BILLING_CYCLE.THREE_YEARS]: `${translation('billing.billing_cycle.three_years')}`,
    [BILLING_CYCLE.QUARTERLY]: `${translation('billing.billing_cycle.quarterly')}`,
  }?.[cycle] ?? cycle;
}

export const BillingCycleKeysMapForAx = {
  [BILLING_CYCLE.MONTHLY]: `Monthly Subscription`,
  [BILLING_CYCLE.ANNUAL]: `Annual Subscription`,
  [BILLING_CYCLE.ONE_MONTH]: `One-Month`,
  [BILLING_CYCLE.ONE_TIME]: `Single-Use`,
  [BILLING_CYCLE.TWO_YEARS]: `Two years`,
  [BILLING_CYCLE.THREE_YEARS]: `Three years`,
  [BILLING_CYCLE.QUARTERLY]: `Quarterly`,
}
